__turbopack_context__.v({
  "className": "notosansjp_35a05b45-module__CBp-nW__className",
  "variable": "notosansjp_35a05b45-module__CBp-nW__variable",
});
